export default __webpack_public_path__ + "static/media/logo.b35cd698.png";